import { useState, useRef } from "react";
export const handleToggleCollapse = (
  collapseId,
  setCollapseshow = () => {},
  check = false,
  targetButton = null,
  child = false,
  outsideclick = false
) => {
  const targetCollapse = document.getElementById(collapseId);

  if (targetCollapse) {
    const isShown = targetCollapse.classList.contains("show");
    const bsCollapse = new window.bootstrap.Collapse(targetCollapse);
    if (!child) {
      const allCollapses = document.querySelectorAll(".collapse");
      allCollapses.forEach((collapse) => {
        if (collapse.classList?.length) {
          collapse.classList.forEach((result) => {
            if (result === "show") {
              if (collapse.id !== collapseId) {
                const bsCurrentCollapse = new window.bootstrap.Collapse(
                  collapse
                );
                bsCurrentCollapse.hide();
              }
            }
          });
        }
      });
    }

    if (isShown) {
      bsCollapse.hide();
      if (check) {
        setCollapseshow({ [collapseId]: false });
        if (targetButton) {
          targetButton?.classList.add("collapsed");
        }
      }
    } else {
      bsCollapse.show();
      if (check) {
        setCollapseshow({ [collapseId]: true });
        if (targetButton) {
          targetButton?.classList.remove("collapsed");
        }
      }

      // Close if clicked outside
      if (!outsideclick) {
        const handleClickOutside = (event) => {
          const isBootstrapElement = event.target.closest(
            `
      .modal,
      .dropdown-menu,
      .offcanvas,
      .toast,
      [data-bs-toggle],
      [role="dialog"]
      `
          );

          if (isBootstrapElement) return;
          if (
            targetCollapse &&
            !targetCollapse.contains(event.target) &&
            !event.target.closest('[data-bs-toggle="collapse"]')
          ) {
            bsCollapse.hide();
            if (check) {
              setCollapseshow({ [collapseId]: false });
              if (targetButton) {
                targetButton?.classList.add("collapsed");
              }
            }
            targetButton?.classList.add("collapsed");
            document.removeEventListener("click", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
          }
        };
        document.addEventListener("click", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
      }
    }
  }
};

export const useHoverEffect = () => {
  const [isHovered, setIsHovered] = useState();

  const handleMouseEnter = (key) => setIsHovered({ [key]: true });
  const handleMouseLeave = (key) => setIsHovered({ [key]: false });

  return { isHovered, handleMouseEnter, handleMouseLeave };
};

export const useModal = () => {
  const modalRefs = useRef({});

  const openModal = (modalId) => {
    const modalElement = modalRefs.current[modalId];
    if (modalElement) {
      const modal = new window.bootstrap.Modal(modalElement);
      modal.show();
    }
  };

  return { modalRefs, openModal };
};
